import { useMemo } from 'react';
import type { UserSelf } from '@tt/shared';
import type { FormatContext } from './format';
import { useMe } from './queries';

const fallback: FormatContext = {
  locale: navigator.language || 'en',
  timeZone: 'UTC',
  hoursFormat: 'DECIMAL',
};

export function contextOf(user: UserSelf | undefined): FormatContext {
  if (!user) return fallback;
  return {
    locale: user.locale ?? user.organization.locale ?? fallback.locale,
    timeZone: user.timeZone,
    hoursFormat: user.organization.hoursFormat,
  };
}

/** Locale, time zone and hours format of the signed-in user for all formatting. */
export function useFormat(): FormatContext {
  const { data } = useMe();
  return useMemo(() => contextOf(data), [data]);
}
